
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/changelog",
      function () {
        return require("private-next-pages/changelog.tsx");
      }
    ]);
  